// extracted by mini-css-extract-plugin
export default {"linksSection":"_F-z"};